import React, { useState } from "react";
import { InfoCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { Input, Card, Button, Modal, List, Typography, Tag } from "antd";
const { TextArea } = Input;

const { Title, Paragraph } = Typography;

export default function JournalChat() {
  const [open, setOpen] = useState(false);
  const showModal = () => {
    setOpen(true);
  };
  const handleOk = () => {
    setTimeout(() => {
      setOpen(false);
    }, 3000);
  };
  const handleCancel = () => {
    setOpen(false);
  };
  return (
    <>
      <div className="notebook-chat">
        <div className="notebook-chat-wrapper position-relative">
          <Tag
            className="new-entry-tag"
            closeIcon={<CloseCircleOutlined />}
            closable
          >
            New Entry Received
          </Tag>
          <Card>
            <div className="list-wrapper">
              <List
                className="notebook-chat-list"
                itemLayout="vertical"
                size="large"
              >
                <List.Item>
                  <List.Item.Meta description="Hi i want to write something about myself but i am not getting any point,Hi i want to write something about myself but i am not getting any point,Hi i want to write something about myself but i am not getting any point,Hi i want to write something about myself but i am not getting any point,Hi i want to write something about myself but i am not getting any point,Hi i want to write something about myself but i am not getting any point,Hi i want to write something about myself but i am not getting any point," />
                  <span className="date-time">
                    Wed, Oct 4, 2023 @ 4:59PM from John to Jessica
                  </span>
                </List.Item>
              </List>
            </div>
            <TextArea
              placeholder="Start Writing Here"
              className="note-book"
              minRows={3}
              autoSize={true}
            />
          </Card>
          <div className="notebook-chat-footer">
            <Button disabled size="large" type="primary">
              Post Journal Entry
            </Button>
            <Button size="large" ghost onClick={showModal}>
              Cancel
            </Button>
          </div>
        </div>
        <Modal
          centered
          mask={false}
          open={open}
          onOk={handleOk}
          onCancel={handleCancel}
          closable={false}
          className="post-confirmation-modal"
          okText="Yes, Post"
          cancelText="No, Edit"
          cancelButtonProps={{
            ghost: true,
          }}
        >
          <InfoCircleOutlined />
          <Title level={4}>Confirmation</Title>
          <Paragraph className="text">
            This will be posted to the Journal and neither you nor your
            co-Journalist will be able to create a new entry for 1 hour. This is
            designed to allow both parties to digest what has been said and
            respond accordingly.
          </Paragraph>
          <Paragraph className="text">
            Are you ready to post this journal entry?
          </Paragraph>
        </Modal>
      </div>
    </>
  );
}
